import React from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import SelectField from 'CommonComponents/SelectField';
import TextFormField from 'CommonComponents/TextFormField';

const CommittedExpendituresEditSchema = Yup.object().shape({
    contractReference: Yup.string().nullable(),
    supplierId: Yup.number().required('This value is required'),
});

export default function CommitedExpendituresIndexListEditForm(props) {
    const supplierOptions = props.suppliers.map((supplier) => {
        return { value: supplier.id, label: supplier.name };
    });

    return (
        <Formik
            initialValues={{
                contractReference: props.committedExpenditure.contract_reference ?? '',
                supplierId: props.committedExpenditure.supplier_id ?? undefined,
            }}
            validationSchema={CommittedExpendituresEditSchema}
            onSubmit={(values, actions) => {
                axios
                    .put(
                        props.committedExpendituresUpdateUrl.replace('COMMITTED_EXPENDITURE_ID', props.committedExpenditure.id) +
                            (props.committedExpensable !== undefined ? '?committedExpensable=' + props.committedExpensable.id : ''),
                        values,
                    )
                    .then((response) => {
                        actions.setSubmitting(false);
                        props.successHandler();
                    })
                    .catch((e) => {
                        actions.setSubmitting(false);
                        actions.setErrors(e.response.data.errors);
                    });
            }}
        >
            {({ errors, touched, handleSubmit, isSubmitting, values, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label="Contract Reference" type="text" name="contractReference" placeholder="Contract Reference"></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <div className="tw-flex tw-flex-col tw-space-y-1.5">
                            <label className="text-input__label">Supplier*</label>
                            <SelectField options={supplierOptions} value={values.supplierId} onChange={(value) => setFieldValue('supplierId', value.value)} />
                            {errors.supplierId && touched.supplierId ? <div className="tw-text-red-500 tw-text-sm">{errors.supplierId}</div> : null}
                        </div>
                    </div>
                    <div className="modal__footer">
                        <Button variant="primary" onClick={handleSubmit} disabled={isSubmitting}>
                            {$t('Update')}
                        </Button>
                    </div>
                </>
            )}
        </Formik>
    );
}
